"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDebtServiceCalculator = initDebtServiceCalculator;
const utils_debt_service_calculator_1 = require("./utils-debt-service-calculator");
const stress_test_rule_svg_1 = __importDefault(require("./assets/icons/stress-test-rule.svg"));
const loan_details_svg_1 = __importDefault(require("./assets/icons/loan-details.svg"));
const rental_income_rule_svg_1 = __importDefault(require("./assets/icons/rental-income-rule.svg"));
const add_rental_income_svg_1 = __importDefault(require("./assets/icons/add-rental-income.svg"));
const debt_service_rate_svg_1 = __importDefault(require("./assets/icons/debt-service-rate.svg"));
const home_expense_svg_1 = __importDefault(require("./assets/icons/home-expense.svg"));
const amortization_svg_1 = __importDefault(require("./assets/icons/amortization.svg"));
const dropdown_icon_svg_1 = __importDefault(require("./assets/icons/dropdown-icon.svg"));
function initDebtServiceCalculator(container) {
    const calculatorInputsHTML = `
    <div class="calculator-input mortgage-calculator-input">
      <div class="header stacked">
        <div class="title-wrapper">
          <img src="${loan_details_svg_1.default}" alt="Mortgage Amount icon"/>
          <div class="title">Mortgage Amount</div>
        </div>
      </div>
      <div class="input-fields single-field">
        <div class="input-field load-amount">
          <div class="field-label">Loan Amount</div>
          <input type="text" value="$  500,000" data-previous-value="500000" class="value-input">
          <input type="range" min="0" max="1500000" value="500000" step="10000" class="slider">
          <div class="range-label">
            <span>$0</span>
            <span>$1,500,000+</span>
          </div>
        </div>
      </div>
      <div class="input-fields half-width-fields">
        <div class="input-field gross-annual-income">
          <div class="field-label">Gross Annual Income</div>
          <input type="text" value="$  150,000" data-previous-value="150000" class="value-input">
          <input type="range" min="0" max="500000" value="150000" step="10000" class="slider">
          <div class="range-label">
            <span>$0</span>
            <span>$500,000+</span>
          </div>
        </div>
        <div class="input-field monthly-debt-payments">
          <div class="field-label">Monthly Debt Payments</div>
          <input type="text" value="$  300" data-previous-value="300" class="value-input">
          <input type="range" min="0" max="5000" value="300" step="100" class="slider">
          <div class="range-label">
            <span>$0</span>
            <span>$5,000+</span>
          </div>
        </div>
      </div>
    </div>

    <div class="calculator-input mortgage-calculator-input">
      <div class="header stacked">
        <div class="title-wrapper">
          <img src="${home_expense_svg_1.default}" alt="Home Expenses icon"/>
          <div class="title">Home Expenses</div>
        </div>
        <div class="mortgage-calculator-info">To budget better and calculate a more realistic total monthly cost, enter the additional home expenses here.</div>
      </div>
      <div class="input-fields half-width-fields">
        <div class="input-field home-expense-monthly">
          <div class="field-label">Property Tax (Monthly)</div>
          <input type="text" value="$  200" data-previous-value="200" class="value-input">
        </div>
        <div class="input-field home-expense-yearly">
          <div class="field-label">Property Tax (Yearly)</div>
          <input type="text" value="$  2,400" data-previous-value="2400" class="value-input">
        </div>
      </div>
      <div class="input-fields half-width-fields">
        <div class="input-field home-expense-condo-fees">
          <div class="field-label">Condo fees (Monthly)</div>
          <input type="text" value="$  200" data-previous-value="200" class="value-input">
        </div>
        <div class="input-field home-expense-heat">
          <div class="field-label">Heat (Monthly)</div>
          <input type="text" value="$  200" data-previous-value="200" class="value-input">
        </div>
      </div>
    </div>

    <div class="calculator-input mortgage-calculator-input debt-service-rate">
      <div class="header">
        <div class="title-wrapper">
          <img src="${debt_service_rate_svg_1.default}" alt="Rate icon"/>
          <div class="title">Rate</div>
        </div>
        <div class="btn-group-selector">
          <div class="selector active">Regular</div>
          <div class="selector">Interest Only</div>
        </div>
        <div class="mortgage-calculator-info full-row-width">Your mortgage interest rate can either be Fixed for the term or Variable (which changes with the prime rate). The Rate Term is the contract length with a lender.</div>
      </div>
      <div class="input-fields single-field">
        <div class="dropdown inline compounding">
          <div class="dropdown-field inline-label">
            <div class="field-label">Compounding</div>
            <span>Semi-Annual</span>
            <img class="info-icon" src="${dropdown_icon_svg_1.default}" alt="Dropdown icon"/>  
          </div>
          <div class="dropdown-opts">
            <div class="dropdown-opt">Daily</div>
            <div class="dropdown-opt">Weekly</div>
            <div class="dropdown-opt">Bi-Weekly</div>
            <div class="dropdown-opt">Monthly</div>
            <div class="dropdown-opt">Quarterly</div>
            <div class="dropdown-opt">Semi-Annual</div>
          </div>
        </div>
      </div>
      <div class="input-fields">
        <div class="input-field rate">
          <div class="field-label">Rate</div>
          <input type="text" value="6.29%" data-previous-value="6.29" class="value-input">
          <input type="range" min="0" max="10" value="6.29" step="0.05" class="slider">
        </div>
        <div class="dropdown inline rate-term">
          <div class="dropdown-field inline-label">
            <div class="field-label">Rate Term</div>
            <span>5 years</span>
            <img class="info-icon" src="${dropdown_icon_svg_1.default}" alt="Dropdown icon"/>  
          </div>
          <div class="dropdown-opts">
            <div class="dropdown-opt">1 year</div>
            <div class="dropdown-opt">2 years</div>
            <div class="dropdown-opt">3 years</div>
            <div class="dropdown-opt">4 years</div>
            <div class="dropdown-opt">5 years</div>
            <div class="dropdown-opt">7 years</div>
            <div class="dropdown-opt">10 years</div>
          </div>
        </div>
      </div>
    </div>

    <div class="calculator-input mortgage-calculator-input">
      <div class="header stacked">
        <div class="title-wrapper">
          <img src="${amortization_svg_1.default}" alt="Amortization icon"/>
          <div class="title">Amortization</div>
        </div>
        <div class="mortgage-calculator-info">Amortization is the total time it takes to pay off your mortgage in full. New mortgages usually start with an amortization of 25 years or 30 years in Canada.</div>
      </div>
      <div class="input-fields single-field">
        <div class="input-field amortization">
          <div class="field-label">Amortization</div>
          <input type="text" value="25 Years" data-previous-value="25" class="value-input">
          <input type="range" min="5" max="30" value="25" step="1" class="slider">
          <div class="range-label">
            <span>5 Year</span>
            <span>30 Years</span>
          </div>
        </div>
      </div>
    </div>

    <div class="calculator-input mortgage-calculator-input add-rental-income">
      <div class="header stacked">
        <div class="title-toggle-wrapper">
          <div class="title-wrapper">
            <img src="${add_rental_income_svg_1.default}" alt="Add Rental Income icon"/>
            <div class="title">Add Rental Income</div>
          </div>
          <div class="toggle">
            <div class="opt off selected" data-value="off"></div>
            <div class="opt on" data-value="on"></div>
          </div>
        </div>
        <div class="mortgage-calculator-info">If you plan to rent out part of your home, enter the rent amount here to reduce your total monthly cost.</div>
      </div>

      <div class="input-fields half-width-fields expandable">
        <div class="input-field add-rental-income-monthly">
          <div class="field-label">Monthly</div>
          <input type="text" value="$  200" data-previous-value="200" class="value-input">
        </div>
        <div class="input-field add-rental-income-yearly">
          <div class="field-label">Yearly</div>
          <input type="text" value="$  2,400" data-previous-value="2400" class="value-input">
        </div>
      </div>
    </div>

    <div class="calculator-input mortgage-calculator-input stress-test-rule">
      <div class="header">
        <div class="title-wrapper">
          <img src="${stress_test_rule_svg_1.default}" alt="Stress Test Rule icon"/>
          <div class="title">Stress Test Rule</div>
        </div>
        <div class="btn-group-selector">
          <div class="selector">Contract</div>
          <div class="selector active">B20</div>
        </div>
      </div>
      <div class="input-fields single-field">
        <div class="dropdown inline condo-fee-inclusion-rate">
          <div class="dropdown-field inline-label">
            <div class="field-label">Condo Fee Inclusion Rate</div>
            <span>50%</span>
            <img class="info-icon" src="${dropdown_icon_svg_1.default}" alt="Dropdown icon"/>  
          </div>
          <div class="dropdown-opts">
            <div class="dropdown-opt">0%</div>
            <div class="dropdown-opt">50%</div>
            <div class="dropdown-opt">100%</div>
          </div>
        </div>
      </div>
    </div>

    <div class="calculator-input mortgage-calculator-input rental-income-rule">
      <div class="header">
        <div class="title-wrapper">
          <img src="${rental_income_rule_svg_1.default}" alt="Rental Income Rule icon"/>
          <div class="title">Rental Income Rule</div>
        </div>
        <div class="btn-group-selector">
          <div class="selector">Add Back</div>
          <div class="selector active">Offset</div>
        </div>
      </div>
      <div class="input-fields single-field">
        <div class="dropdown inline rental-income-portion">
          <div class="dropdown-field inline-label">
            <div class="field-label">Rental Income Portion</div>
            <span>50%</span>
            <img class="info-icon" src="${dropdown_icon_svg_1.default}" alt="Dropdown icon"/>  
          </div>
          <div class="dropdown-opts">
            <div class="dropdown-opt">25%</div>
            <div class="dropdown-opt">50%</div>
            <div class="dropdown-opt">75%</div>
            <div class="dropdown-opt">100%</div>
          </div>
        </div>
      </div>
    </div>
  `;
    const calculatorResultsHTML = `
    <div class="debt-service-ratios">
      <div class="label">Debt Service Ratios</div>
      <div class="ratios">
        <div class="ratio">
          <div class="value">28.546%</div>
          <div class="value-label">GDS</div>
        </div>
        <div class="ratio">
          <div class="value">30.946%</div>
          <div class="value-label">TDS</div>
        </div>
      </div>
      <div class="details">
        <div class="st-rate">
          <div class="st-rate-label">Stress Test Rate (<span>CONTRACT</span>)</div>
          <div class="st-rate-value">6.29%</div>
        </div>
        <div class="ratio-tags">
          <div class="ratio-tag ratio-tag-32">32%/40%</div>
          <div class="ratio-tag ratio-tag-35">35%/42%</div>
          <div class="ratio-tag ratio-tag-39">39%/44%</div>
        </div>
        <div class="debt-service-details">
          <div class="service-detail monthly-mortgage">
            <div class="service-detail-icon"></div>
            <div class="service-detail-name">Monthly Mortgage</div>
            <div class="service-detail-value">$2,934.93</div>
          </div>
          <div class="service-detail debt-payment">
            <div class="service-detail-icon"></div>
            <div class="service-detail-name">Debt Payment</div>
            <div class="service-detail-value">$300.00</div>
          </div>
          <div class="service-detail home-expenses">
            <div class="service-detail-icon"></div>
            <div class="service-detail-name">Home Expenses <span>(incl. rental offset)</span></div>
            <div class="service-detail-value">$1,233.33</div>
          </div>
          <div class="service-detail cash-left">
            <div class="service-detail-icon"></div>
            <div class="service-detail-name">Cash Left (Gross)</div>
            <div class="service-detail-value">$8,531.74</div>
          </div>
        </div>
      </div>
    </div>
  `;
    container.innerHTML = `
    <div class="mortgage-calculator">
        <div class="section-heading">Debt Service Calculator</div>
        <div class="tab-layout">
          <div class="tab-content active">
            <div class="calculator-inputs">
              ${calculatorInputsHTML}
            </div>
            <div class="calculator-results debt-service-calculator-results">
              ${calculatorResultsHTML}
            </div>
          </div>
        </div>
    </div>
  `;
    const loanAmountInput = document.querySelector('.load-amount .value-input');
    const loanAmountInputSlider = document.querySelector('.load-amount .slider');
    const grossAnnualIncomeInput = document.querySelector('.gross-annual-income .value-input');
    const grossAnnualIncomeInputSlider = document.querySelector('.gross-annual-income .slider');
    const monthlyDebtPaymentsInput = document.querySelector('.monthly-debt-payments .value-input');
    const monthlyDebtPaymentsInputSlider = document.querySelector('.monthly-debt-payments .slider');
    const homeExpenseMonthlyInput = document.querySelector('.home-expense-monthly .value-input');
    const homeExpenseYearlyInput = document.querySelector('.home-expense-yearly .value-input');
    const homeExpenseCondoFeesInput = document.querySelector('.home-expense-condo-fees .value-input');
    const homeExpenseHeatInput = document.querySelector('.home-expense-heat .value-input');
    const addRentalIncomeExpandableElement = document.querySelector('.add-rental-income .expandable');
    const addRentalIncomeMonthlyInput = document.querySelector('.add-rental-income-monthly .value-input');
    const addRentalIncomeYearlyInput = document.querySelector('.add-rental-income-yearly .value-input');
    const interestRateInput = document.querySelector('.rate .value-input');
    const interestRateInputSlider = document.querySelector('.rate .slider');
    const compoundingFrequencyValueElement = document.querySelector('.compounding .dropdown-field span');
    const condoFeeInclusionRateValueElement = document.querySelector('.condo-fee-inclusion-rate .dropdown-field span');
    const rentalIncomePortionRateValueElement = document.querySelector('.rental-income-portion .dropdown-field span');
    const amortizationInput = document.querySelector('.amortization .value-input');
    const amortizationInputSlider = document.querySelector('.amortization .slider');
    const gdsRatioResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .ratios .ratio:nth-of-type(1) .value');
    const tdsRatioResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .ratios .ratio:nth-of-type(2) .value');
    const stressTestRateTypeResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .details .st-rate .st-rate-label span');
    const stressTestRateResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .details .st-rate .st-rate-value');
    const ratioTagsResultElements = document.querySelectorAll('.debt-service-calculator-results .debt-service-ratios .details .ratio-tags .ratio-tag');
    const monthlyMortgageResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .details .debt-service-details .monthly-mortgage .service-detail-value');
    const debtPaymentResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .details .debt-service-details .debt-payment .service-detail-value');
    const homeExpenseSpanResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .details .debt-service-details .home-expenses .service-detail-name span');
    const homeExpenseResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .details .debt-service-details .home-expenses .service-detail-value');
    const cashLeftResultsElement = document.querySelector('.debt-service-calculator-results .debt-service-ratios .details .debt-service-details .cash-left .service-detail-value');
    const debtServiceRateSelectorElements = document.querySelectorAll('.debt-service-rate .btn-group-selector .selector');
    const stressTestRuleSelectorElements = document.querySelectorAll('.stress-test-rule .btn-group-selector .selector');
    const rentalIncomeRuleSelectorElements = document.querySelectorAll('.rental-income-rule .btn-group-selector .selector');
    const addRentalIncomeToggleSelectorElements = document.querySelectorAll('.add-rental-income .opt');
    const tooltipElements = document.querySelectorAll("[data-tooltip]");
    const dropdownOpts = document.querySelectorAll('.dropdown-opt');
    dropdownOpts.forEach(dropdownOpt => {
        dropdownOpt.addEventListener('click', () => {
            var _a, _b;
            const prevEl = (_a = dropdownOpt.parentElement) === null || _a === void 0 ? void 0 : _a.previousElementSibling;
            const span = prevEl === null || prevEl === void 0 ? void 0 : prevEl.querySelector('span');
            if (span) {
                span.textContent = dropdownOpt.textContent;
            }
            (_b = dropdownOpt.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove("expanded");
            prevEl === null || prevEl === void 0 ? void 0 : prevEl.classList.remove('dropdown-expanded');
            updateResults();
        });
    });
    document.querySelectorAll('.dropdown-field').forEach(field => {
        field.addEventListener('click', (e) => {
            var _a;
            e.stopPropagation();
            const expandedDropdownElement = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest('.dropdown-expanded');
            if (expandedDropdownElement) {
                document.querySelectorAll('.dropdown-opts.expanded').forEach(opt => {
                    var _a;
                    (_a = opt.previousElementSibling) === null || _a === void 0 ? void 0 : _a.classList.remove('dropdown-expanded');
                    opt.classList.remove('expanded');
                });
            }
            else {
                document.querySelectorAll('.dropdown-field.dropdown-expanded').forEach(dropdown => {
                    dropdown.classList.remove('dropdown-expanded');
                });
                document.querySelectorAll('.dropdown-opts.expanded').forEach(opt => {
                    opt.classList.remove('expanded');
                });
                const opts = field.nextElementSibling;
                opts === null || opts === void 0 ? void 0 : opts.classList.toggle('expanded');
                if ((opts === null || opts === void 0 ? void 0 : opts.classList.contains('expanded')) && opts.previousElementSibling) {
                    opts.style.top = `${opts.previousElementSibling.clientHeight + 5}px`;
                    field.classList.add('dropdown-expanded');
                }
            }
        });
    });
    document.addEventListener('click', (e) => {
        const target = e.target;
        if (!target.closest('.dropdown')) {
            document.querySelectorAll('.dropdown-opts.expanded').forEach(opt => {
                var _a;
                (_a = opt.previousElementSibling) === null || _a === void 0 ? void 0 : _a.classList.remove('dropdown-expanded');
                opt.classList.remove('expanded');
            });
        }
    });
    debtServiceRateSelectorElements.forEach((selector, index) => {
        selector.addEventListener('click', () => {
            debtServiceRateSelectorElements.forEach(h => h.classList.remove('active'));
            selector.classList.add('active');
            updateResults();
        });
    });
    stressTestRuleSelectorElements.forEach((selector, index) => {
        selector.addEventListener('click', () => {
            stressTestRuleSelectorElements.forEach(h => h.classList.remove('active'));
            selector.classList.add('active');
            updateResults();
        });
    });
    rentalIncomeRuleSelectorElements.forEach((selector, index) => {
        selector.addEventListener('click', () => {
            rentalIncomeRuleSelectorElements.forEach(h => h.classList.remove('active'));
            selector.classList.add('active');
            updateResults();
        });
    });
    addRentalIncomeToggleSelectorElements.forEach((selector, index) => {
        selector.addEventListener('click', () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            const prevValue = (_b = (_a = document.querySelector('.title-toggle-wrapper .toggle .selected')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.value;
            const newValue = prevValue === 'off' ? 'on' : 'off';
            addRentalIncomeToggleSelectorElements.forEach(h => h.classList.remove('selected'));
            if (newValue === 'on') {
                document.querySelector('.title-toggle-wrapper .toggle .on').classList.add('selected');
            }
            else {
                document.querySelector('.title-toggle-wrapper .toggle .off').classList.add('selected');
            }
            (_c = selector.parentElement) === null || _c === void 0 ? void 0 : _c.classList.remove('switched-on');
            (_g = (_f = (_e = (_d = selector.parentElement) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.parentElement) === null || _f === void 0 ? void 0 : _f.nextElementSibling) === null || _g === void 0 ? void 0 : _g.classList.remove('expanded');
            if (newValue === 'on') {
                (_h = selector.parentElement) === null || _h === void 0 ? void 0 : _h.classList.add('switched-on');
                (_m = (_l = (_k = (_j = selector.parentElement) === null || _j === void 0 ? void 0 : _j.parentElement) === null || _k === void 0 ? void 0 : _k.parentElement) === null || _l === void 0 ? void 0 : _l.nextElementSibling) === null || _m === void 0 ? void 0 : _m.classList.add('expanded');
            }
            else {
                addRentalIncomeMonthlyInput.value = '$  0';
                addRentalIncomeMonthlyInput.dataset.previousValue = '0';
                addRentalIncomeYearlyInput.value = '$  0';
                addRentalIncomeYearlyInput.dataset.previousValue = '0';
            }
            updateResults();
        });
    });
    ratioTagsResultElements.forEach(ratioTagResultElement => {
        ratioTagResultElement.addEventListener('click', (event) => {
            var _a, _b;
            const targetElement = event.target;
            let targetGdsRatio = 32;
            if (targetElement.classList.contains("ratio-tag-35")) {
                targetGdsRatio = 35;
            }
            else if (targetElement.classList.contains("ratio-tag-39")) {
                targetGdsRatio = 39;
            }
            const loanAmountValue = loanAmountInput.dataset.previousValue ? parseInt(loanAmountInput.dataset.previousValue) : 0;
            const grossAnnualIncomeValue = grossAnnualIncomeInput.dataset.previousValue ? parseInt(grossAnnualIncomeInput.dataset.previousValue) : 0;
            const monthlyDebtPaymentsValue = monthlyDebtPaymentsInput.dataset.previousValue ? parseInt(monthlyDebtPaymentsInput.dataset.previousValue) : 0;
            const propertTaxMonthlyValue = homeExpenseMonthlyInput.dataset.previousValue ? parseFloat(parseFloat(homeExpenseMonthlyInput.dataset.previousValue).toFixed(2)) : 0;
            const condoFeesValue = homeExpenseCondoFeesInput.dataset.previousValue ? parseInt(homeExpenseCondoFeesInput.dataset.previousValue) : 0;
            const heatingCostValue = homeExpenseHeatInput.dataset.previousValue ? parseInt(homeExpenseHeatInput.dataset.previousValue) : 0;
            const interestRateValue = interestRateInput.dataset.previousValue ? parseFloat(parseFloat(interestRateInput.dataset.previousValue).toFixed(2)) : 0;
            const amortizationValue = amortizationInput.dataset.previousValue ? parseInt(amortizationInput.dataset.previousValue) : 5;
            const rentalIncomeMonthlyValue = addRentalIncomeMonthlyInput.dataset.previousValue ? parseInt(addRentalIncomeMonthlyInput.dataset.previousValue) : 0;
            const compoundingFrequencyValue = compoundingFrequencyValueElement.textContent ? compoundingFrequencyValueElement.textContent.toLowerCase() : "semi-annual";
            const stressTestTypeActiveElement = document.querySelector(".stress-test-rule .btn-group-selector .active");
            const rentalIncomeMethodActiveElement = document.querySelector(".rental-income-rule .btn-group-selector .active");
            const rawStressTest = ((_a = stressTestTypeActiveElement.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'contract';
            const stressTestTypeValue = isStressTestType(rawStressTest) ? rawStressTest : 'contract';
            const rawRentalMethod = ((_b = rentalIncomeMethodActiveElement.textContent) === null || _b === void 0 ? void 0 : _b.toLowerCase().replace(" ", "-")) || 'offset';
            const rentalIncomeMethodValue = isRentalIncomeMethod(rawRentalMethod) ? rawRentalMethod : 'offset';
            const inputData = {
                mortgageAmount: loanAmountValue,
                grossAnnualIncome: grossAnnualIncomeValue,
                monthlyDebtPayments: monthlyDebtPaymentsValue,
                propertyTaxMonthly: propertTaxMonthlyValue,
                condoFees: condoFeesValue,
                heatingCost: heatingCostValue,
                interestRate: interestRateValue,
                amortizationYears: amortizationValue,
                isRentalIncomeEnabled: addRentalIncomeExpandableElement.classList.contains("expanded"),
                rentalIncomeMonthly: rentalIncomeMonthlyValue,
            };
            const idealAmount = (0, utils_debt_service_calculator_1.calculateIdealMortgageAmount)(targetGdsRatio, inputData, compoundingFrequencyValue, 50, 50, stressTestTypeValue, rentalIncomeMethodValue);
            if (idealAmount > 0 && idealAmount <= 1500000) {
                const inputValue = Math.round(idealAmount);
                loanAmountInputSlider.value = inputValue.toString();
                loanAmountInput.value = inputValue ? `$  ${inputValue.toLocaleString('en-US')}` : '';
                loanAmountInput.dataset.previousValue = inputValue.toString();
                updateSliderBackground(loanAmountInputSlider);
                updateResults();
            }
        });
    });
    tooltipElements.forEach(el => {
        const tooltipText = el.getAttribute("data-tooltip");
        const tooltip = document.createElement("div");
        tooltip.className = "custom-tooltip";
        tooltip.textContent = tooltipText;
        document.body.appendChild(tooltip);
        el.addEventListener("mousemove", (e) => {
            const event = e;
            tooltip.style.top = `${event.pageY + 20}px`;
            tooltip.style.left = `${(event.pageX - (tooltip.clientWidth / 2))}px`;
        });
        el.addEventListener("mouseenter", (e) => {
            tooltip.style.opacity = "1";
            tooltip.style.pointerEvents = "none";
        });
        el.addEventListener("mouseleave", () => {
            tooltip.style.opacity = "0";
        });
    });
    function updateSliderBackground(slider) {
        const value = Number(slider.value);
        const min = Number(slider.min);
        const max = Number(slider.max);
        const percent = ((value - min) / (max - min)) * 100;
        slider.style.background = `linear-gradient(to right, #1A4383 ${percent}%, #1A43832f ${percent}%)`;
    }
    loanAmountInputSlider.addEventListener("input", () => {
        const inputValue = loanAmountInputSlider.value.replace(/[^0-9.]/g, '');
        loanAmountInput.value = inputValue ? `$  ${parseInt(inputValue).toLocaleString('en-US')}` : '';
        loanAmountInput.dataset.previousValue = inputValue;
        updateSliderBackground(loanAmountInputSlider);
        updateResults();
    });
    grossAnnualIncomeInputSlider.addEventListener("input", () => {
        const inputValue = grossAnnualIncomeInputSlider.value.replace(/[^0-9.]/g, '');
        grossAnnualIncomeInput.value = inputValue ? `$  ${parseInt(inputValue).toLocaleString('en-US')}` : '';
        grossAnnualIncomeInput.dataset.previousValue = inputValue;
        updateSliderBackground(grossAnnualIncomeInputSlider);
        updateResults();
    });
    monthlyDebtPaymentsInputSlider.addEventListener("input", () => {
        const inputValue = monthlyDebtPaymentsInputSlider.value.replace(/[^0-9.]/g, '');
        monthlyDebtPaymentsInput.value = inputValue ? `$  ${parseInt(inputValue).toLocaleString('en-US')}` : '';
        monthlyDebtPaymentsInput.dataset.previousValue = inputValue;
        updateSliderBackground(monthlyDebtPaymentsInputSlider);
        updateResults();
    });
    interestRateInputSlider.addEventListener("input", () => {
        const inputValue = interestRateInputSlider.value.replace(/[^0-9.]/g, '');
        interestRateInput.value = inputValue ? `${parseFloat(inputValue).toFixed(2)}%` : '';
        interestRateInput.dataset.previousValue = inputValue;
        updateSliderBackground(interestRateInputSlider);
        updateResults();
    });
    amortizationInputSlider.addEventListener("input", () => {
        const inputValue = amortizationInputSlider.value.replace(/[^0-9.]/g, '');
        amortizationInput.value = inputValue ? `${parseInt(inputValue).toLocaleString('en-US')} Years` : '';
        amortizationInput.dataset.previousValue = inputValue;
        updateSliderBackground(amortizationInputSlider);
        updateResults();
    });
    const formatInput = (inputElement, symbol, type) => {
        inputElement.addEventListener('change', (event) => {
            const target = event.target;
            if (target) {
                let value = target.value;
                value = value.replace(/[^0-9.]/g, ''); // Remove non-numeric characters
                const numericValue = value ? parseInt(value) : 0;
                switch (type) {
                    case "loan-amount":
                        if (0 <= numericValue) {
                            loanAmountInputSlider.value = numericValue.toString();
                            updateSliderBackground(loanAmountInputSlider);
                            target.value = `${symbol}  ${parseInt(value).toLocaleString('en-US')}`;
                            target.dataset.previousValue = value;
                        }
                        else if (target.dataset.previousValue) {
                            target.value = `${symbol}  ${parseInt(target.dataset.previousValue).toLocaleString('en-US')}`;
                        }
                        break;
                    case "gross-annual-income":
                        if (0 <= numericValue) {
                            grossAnnualIncomeInputSlider.value = numericValue.toString();
                            updateSliderBackground(grossAnnualIncomeInputSlider);
                            target.value = `${symbol}  ${parseInt(value).toLocaleString('en-US')}`;
                            target.dataset.previousValue = value;
                        }
                        else if (target.dataset.previousValue) {
                            target.value = `${symbol}  ${parseInt(target.dataset.previousValue).toLocaleString('en-US')}`;
                        }
                        break;
                    case "monthly-debt-payments":
                        if (0 <= numericValue) {
                            monthlyDebtPaymentsInputSlider.value = numericValue.toString();
                            updateSliderBackground(monthlyDebtPaymentsInputSlider);
                            target.value = `${symbol}  ${parseInt(value).toLocaleString('en-US')}`;
                            target.dataset.previousValue = value;
                        }
                        else if (target.dataset.previousValue) {
                            target.value = `${symbol}  ${parseInt(target.dataset.previousValue).toLocaleString('en-US')}`;
                        }
                        break;
                    case "home-expense-monthly":
                    case "home-expense-yearly":
                    case "home-expense-condo-fees":
                    case "home-expense-heat":
                    case "add-rental-income-monthly":
                    case "add-rental-income-yearly":
                        if (0 <= numericValue) {
                            target.value = `${symbol}  ${parseInt(value).toLocaleString('en-US')}`;
                            target.dataset.previousValue = value;
                        }
                        else if (target.dataset.previousValue) {
                            target.value = `${symbol}  ${parseInt(target.dataset.previousValue).toLocaleString('en-US')}`;
                        }
                        if (type === "home-expense-monthly") {
                            const prevValueStr = target.dataset.previousValue;
                            const prevValue = prevValueStr ? parseInt(prevValueStr) : 0;
                            const rawYearlyValue = prevValue * 12;
                            homeExpenseYearlyInput.value = `${symbol} ${rawYearlyValue.toLocaleString('en-US')}`;
                            homeExpenseYearlyInput.dataset.previousValue = rawYearlyValue.toString();
                        }
                        else if (type === "home-expense-yearly") {
                            const prevValueStr = target.dataset.previousValue;
                            const prevValue = prevValueStr ? parseInt(prevValueStr) : 0;
                            const rawMonthlyValue = prevValue / 12;
                            homeExpenseMonthlyInput.value = `${symbol} ${rawMonthlyValue.toLocaleString('en-US')}`;
                            homeExpenseMonthlyInput.dataset.previousValue = rawMonthlyValue.toString();
                        }
                        else if (type === "add-rental-income-monthly") {
                            const prevValueStr = target.dataset.previousValue;
                            const prevValue = prevValueStr ? parseInt(prevValueStr) : 0;
                            const rawYearlyValue = prevValue * 12;
                            addRentalIncomeYearlyInput.value = `${symbol} ${rawYearlyValue.toLocaleString('en-US')}`;
                            addRentalIncomeYearlyInput.dataset.previousValue = rawYearlyValue.toString();
                        }
                        else if (type === "add-rental-income-yearly") {
                            const prevValueStr = target.dataset.previousValue;
                            const prevValue = prevValueStr ? parseInt(prevValueStr) : 0;
                            const rawMonthlyValue = prevValue / 12;
                            addRentalIncomeMonthlyInput.value = `${symbol} ${rawMonthlyValue.toLocaleString('en-US')}`;
                            addRentalIncomeMonthlyInput.dataset.previousValue = rawMonthlyValue.toString();
                        }
                        break;
                    case "interest-rate":
                        const floatValue = value ? parseFloat(value) : 0.00;
                        if (0.1 <= floatValue && floatValue <= 10) {
                            interestRateInputSlider.value = floatValue.toFixed(2);
                            updateSliderBackground(interestRateInputSlider);
                            target.value = `${floatValue.toFixed(2)}%`;
                            target.dataset.previousValue = floatValue.toFixed(2);
                        }
                        else if (target.dataset.previousValue) {
                            target.value = `${parseFloat(target.dataset.previousValue).toFixed(2)}%`;
                        }
                        break;
                    case "amortization-period":
                        if (5 <= numericValue && numericValue <= 30) {
                            amortizationInputSlider.value = numericValue.toString();
                            updateSliderBackground(amortizationInputSlider);
                            target.value = `${parseInt(value).toLocaleString('en-US')} ${symbol}`;
                            target.dataset.previousValue = value;
                        }
                        else if (target.dataset.previousValue) {
                            target.value = `${parseInt(target.dataset.previousValue).toLocaleString('en-US')} ${symbol}`;
                        }
                        break;
                    default:
                        break;
                }
                updateResults();
            }
        });
    };
    function isStressTestType(value) {
        return value === 'contract' || value === 'b20';
    }
    function isRentalIncomeMethod(value) {
        return value === 'offset' || value === 'add-back';
    }
    const updateResults = () => {
        var _a, _b;
        const loanAmountValue = loanAmountInput.dataset.previousValue ? parseInt(loanAmountInput.dataset.previousValue) : 0;
        const grossAnnualIncomeValue = grossAnnualIncomeInput.dataset.previousValue ? parseInt(grossAnnualIncomeInput.dataset.previousValue) : 0;
        const monthlyDebtPaymentsValue = monthlyDebtPaymentsInput.dataset.previousValue ? parseInt(monthlyDebtPaymentsInput.dataset.previousValue) : 0;
        const propertTaxMonthlyValue = homeExpenseMonthlyInput.dataset.previousValue ? parseFloat(parseFloat(homeExpenseMonthlyInput.dataset.previousValue).toFixed(2)) : 0;
        const condoFeesValue = homeExpenseCondoFeesInput.dataset.previousValue ? parseInt(homeExpenseCondoFeesInput.dataset.previousValue) : 0;
        const heatingCostValue = homeExpenseHeatInput.dataset.previousValue ? parseInt(homeExpenseHeatInput.dataset.previousValue) : 0;
        const interestRateValue = interestRateInput.dataset.previousValue ? parseFloat(parseFloat(interestRateInput.dataset.previousValue).toFixed(2)) : 0;
        const amortizationValue = amortizationInput.dataset.previousValue ? parseInt(amortizationInput.dataset.previousValue) : 5;
        const rentalIncomeMonthlyValue = addRentalIncomeMonthlyInput.dataset.previousValue ? parseInt(addRentalIncomeMonthlyInput.dataset.previousValue) : 0;
        const compoundingFrequencyValue = compoundingFrequencyValueElement.textContent ? compoundingFrequencyValueElement.textContent.toLowerCase() : "semi-annual";
        const stressTestRate = 5.25;
        const condoFeeInclusionRateValue = condoFeeInclusionRateValueElement.textContent ? parseInt(condoFeeInclusionRateValueElement.textContent.replace("%", "")) : 50;
        const rentalIncomePortionRateValue = rentalIncomePortionRateValueElement.textContent ? parseInt(rentalIncomePortionRateValueElement.textContent.replace("%", "")) : 50;
        const stressTestTypeActiveElement = document.querySelector(".stress-test-rule .btn-group-selector .active");
        const rentalIncomeMethodActiveElement = document.querySelector(".rental-income-rule .btn-group-selector .active");
        const rawStressTest = ((_a = stressTestTypeActiveElement.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'contract';
        const stressTestTypeValue = isStressTestType(rawStressTest) ? rawStressTest : 'contract';
        const rawRentalMethod = ((_b = rentalIncomeMethodActiveElement.textContent) === null || _b === void 0 ? void 0 : _b.toLowerCase().replace(" ", "-")) || 'offset';
        const rentalIncomeMethodValue = isRentalIncomeMethod(rawRentalMethod) ? rawRentalMethod : 'offset';
        const inputData = {
            mortgageAmount: loanAmountValue,
            grossAnnualIncome: grossAnnualIncomeValue,
            monthlyDebtPayments: monthlyDebtPaymentsValue,
            propertyTaxMonthly: propertTaxMonthlyValue,
            condoFees: condoFeesValue,
            heatingCost: heatingCostValue,
            interestRate: interestRateValue,
            amortizationYears: amortizationValue,
            isRentalIncomeEnabled: addRentalIncomeExpandableElement.classList.contains("expanded"),
            rentalIncomeMonthly: rentalIncomeMonthlyValue,
        };
        const resultObj = (0, utils_debt_service_calculator_1.calculateAllRatios)(inputData, compoundingFrequencyValue, stressTestRate, condoFeeInclusionRateValue, rentalIncomePortionRateValue, stressTestTypeValue, rentalIncomeMethodValue);
        gdsRatioResultsElement.textContent = stressTestTypeValue === "b20" ? `${resultObj.stressTestGDS.toFixed(3)}%` : `${resultObj.gdsRatio.toFixed(3)}%`;
        tdsRatioResultsElement.textContent = stressTestTypeValue === "b20" ? `${resultObj.stressTestTDS.toFixed(3)}%` : `${resultObj.tdsRatio.toFixed(3)}%`;
        stressTestRateTypeResultsElement.textContent = stressTestTypeValue.toUpperCase();
        stressTestRateResultsElement.textContent = `${resultObj.stressTestRate.toFixed(2)}%`;
        monthlyMortgageResultsElement.textContent = (0, utils_debt_service_calculator_1.formatCurrencyDetailed)(resultObj.monthlyMortgagePayment);
        debtPaymentResultsElement.textContent = (0, utils_debt_service_calculator_1.formatCurrencyDetailed)(inputData.monthlyDebtPayments);
        homeExpenseSpanResultsElement.style.display = rentalIncomeMethodValue.toLowerCase() === "offset" ? "unset" : "none";
        homeExpenseResultsElement.textContent = (0, utils_debt_service_calculator_1.formatCurrencyDetailed)(resultObj.monthlyHomeExpenses);
        cashLeftResultsElement.textContent = (0, utils_debt_service_calculator_1.formatCurrencyDetailed)(resultObj.cashLeftGross);
    };
    formatInput(loanAmountInput, '$', 'loan-amount');
    updateSliderBackground(loanAmountInputSlider);
    formatInput(grossAnnualIncomeInput, '$', 'gross-annual-income');
    updateSliderBackground(grossAnnualIncomeInputSlider);
    formatInput(monthlyDebtPaymentsInput, '$', 'monthly-debt-payments');
    updateSliderBackground(monthlyDebtPaymentsInputSlider);
    formatInput(homeExpenseMonthlyInput, '$', 'home-expense-monthly');
    formatInput(homeExpenseYearlyInput, '$', 'home-expense-yearly');
    formatInput(homeExpenseCondoFeesInput, '$', 'home-expense-condo-fees');
    formatInput(homeExpenseHeatInput, '$', 'home-expense-heat');
    formatInput(addRentalIncomeMonthlyInput, '$', 'add-rental-income-monthly');
    formatInput(addRentalIncomeYearlyInput, '$', 'add-rental-income-yearly');
    formatInput(interestRateInput, '%', 'interest-rate');
    updateSliderBackground(interestRateInputSlider);
    formatInput(amortizationInput, 'Years', 'amortization-period');
    updateSliderBackground(amortizationInputSlider);
    updateResults();
}
